<app-board></app-board>
<router-outlet></router-outlet>